import { Breadcrumb as AntdBC } from "antd"
import React from "react"

const Breadcrumb = ({ list = [] }) => {
  return (
    <AntdBC className="mbe-8">
      {list.map((item, index) => (
        <AntdBC.Item key={index}>{item}</AntdBC.Item>
      ))}
    </AntdBC>
  )
}

export default Breadcrumb
